import { isBlank } from './object'

export function paginatePer(per = 50) {
  const page_size = sessionStorage.getItem('pagination_page_size')
  return !isBlank(page_size) ? parseInt(page_size) : per
}
